import { render, staticRenderFns } from "./SliderComponent.vue?vue&type=template&id=7591e8e0"
import script from "./SliderComponent.vue?vue&type=script&lang=js"
export * from "./SliderComponent.vue?vue&type=script&lang=js"
import style0 from "./SliderComponent.vue?vue&type=style&index=0&id=7591e8e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports